import React from 'react';

const Footer = () => {
    return (
        <>

<div className="footer">
    Created By <a className="links" href="https://github.com/autumn-absconds">Shubham Yadav</a>
</div>



        </>
    )
}

export default Footer;
